var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"month-entry",class:{ 'conflict-entry': _vm.isConflict, 'cancelled-entry': _vm.isCancelled },style:({
    backgroundColor: _vm.terminEntryDTO.veranstaltung
      ? _vm.terminEntryDTO.veranstaltung.color
      : '',
  }),on:{"click":_vm.openTimeBlockShowDetailsModal,"mouseenter":_vm.emitShowPopup,"mouseleave":_vm.emitHidePopup}},[_c('div',{staticClass:"entry-compact"},[_c('span',{staticClass:"entry-time-compact"},[_vm._v(" "+_vm._s(_vm.terminEntryDTO.von_uhrzeit)+" - "+_vm._s(_vm.terminEntryDTO.bis_uhrzeit)+" ")]),_c('span',{staticClass:"entry-title-compact"},[_vm._v(" "+_vm._s(_vm.terminEntryDTO.bezeichnung || '(No subject)')+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }